import { Component, inject, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  DateAdapter,
  NativeDateAdapter,
} from '@angular/material/core';
import { Injectable } from '@angular/core';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';

@Injectable()
class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
// Define custom date formats
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-vacation-driver-request-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatDividerModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    DatePipe,
    MatSelectModule,
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
  templateUrl: './vacation-driver-request-dialog.component.html',
  styleUrls: ['./vacation-driver-request-dialog.component.css', '../../../styles/layout.css'],
})
export class VacationDriverRequestDialogComponent {
  // Variables
  startDate: Date | null = null;
  endDate: Date | null = null;  
  requestType: 'holidays' | 'personal_day' = 'holidays';

  // Variable para prevenir múltiples ejecuciones
  isDeleting = false;

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<VacationDriverRequestDialogComponent>,
  ) {}

  // Metodo para abrir el snackbar
  private _snackBar = inject(MatSnackBar);
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 7000,
    });
  }

  getVacationDays(): number {
    if (!this.startDate || !this.endDate) return 0;

    const ms = this.endDate.getTime() - this.startDate.getTime();

    return Math.floor(ms / (1000 * 60 * 60 * 24)) + 1;
  }

  // Función para eliminar
  deleteSelected() {
    if (this.isDeleting) return;

    this.isDeleting = true;

    this.dialogRef.close({
      startDate: this.startDate,
      endDate: this.endDate,
    });
  }

  onCancel() {
    if (this.isDeleting) {
      return;
    }
    this.dialogRef.close(false);
  }

  onAccept() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    this.dialogRef.close({
      type: this.requestType,
      startDate: this.startDate,
      endDate: this.endDate,
    });
  }

}
